export const messages = {
  en: {
    purchaseApplyDetail: {
      applyInfo: 'Application Information',
      print: 'Print',
      back: 'Back',
      applyNo: 'Application No:',
      applicant: 'Applicant:',
      endUser: 'End User:',
      contactPhone: 'Contact Phone:',
      applyTime: 'Application Time:',
      referenceTotalPrice: 'Reference Total Price:',
      approvalStatus: 'Approval Status:',
      storageMethod: 'Storage Method',
      outboundMethod: 'Outbound Method',
      directStorage: 'Direct Storage',
      purchaseStorage: 'Purchase Storage',
      emergencyPurchase: 'Emergency Purchase',
      directOutbound: 'Direct Outbound',
      auditOutbound: 'Audit Outbound',
      description: 'Description:',
      referencePurchaseTotalPrice: 'Reference Purchase Total Price:',
      actualPurchaseTotalPrice: 'Actual Purchase Total Price:',
      applyMaterials: 'Application Materials',
      itemType: 'Item Type',
      itemName: 'Item Name',
      warehouse: 'Warehouse',
      itemSpec: 'Item Specification',
      supplier: 'Supplier',
      itemCode: 'Item Code',
      fixedItem: 'Fixed Item',
      referencePrice: 'Reference Price',
      originalStock: 'Original Stock',
      currentStock: 'Current Stock',
      applyQuantity: 'Apply Quantity',
      applyRemark: 'Apply Remark',
      purchasePrice: 'Purchase Price',
      purchaseQuantity: 'Purchase Quantity',
      receiveQuantity: 'Receive Quantity',
      purchaseRemark: 'Purchase Remark',
      receiveRemark: 'Receive Remark',
      workOrderFlow: 'Work Order Flow',
      serialNumber: 'No.',
      handler: 'Handler',
      status: 'Status',
      handleTime: 'Handle Time',
      timeConsuming: 'Time Consuming',
      opinion: 'Opinion',
      cancel: 'Cancel',
      time: 'Time',
      manufacturerSignature: 'Manufacturer Signature',
      purchaserSignature: 'Purchaser Signature',
      remark: 'Remark',
      reviewerSignature: 'Reviewer Signature',
      applicantSignature: 'Applicant Signature'
    },
    auditDiv: {
      workOrderProcessing: 'Work Order Processing',
      action: 'Action',
      pleaseSelect: 'Please Select',
      agree: 'Agree',
      return: 'Return',
      returnToSubmitter: 'Return to Submitter',
      transfer: 'Transfer',
      workOrderDescription: 'Work Order Description',
      requiredDescription: 'Required, please fill in the work order description',
      nextHandler: 'Next Handler',
      requiredNextHandler: 'Required, please select the next handler',
      select: 'Select',
      pleaseSelectStatus: 'Please select status',
      pleaseFillDescription: 'Please fill in the description',
      pleaseSelectNextHandler: 'Please select next handler',
      submitSuccess: 'Submit successfully',
      submitFailed: 'Submit failed'
    },
  },
  zh: {
    purchaseApplyDetail: {
      applyInfo: '申请信息',
      print: '打印',
      back: '返回',
      applyNo: '申请单号：',
      applicant: '申请人：',
      endUser: '使用人：',
      contactPhone: '联系电话：',
      applyTime: '申请时间：',
      referenceTotalPrice: '参考总价：',
      approvalStatus: '审批状态：',
      storageMethod: '入库方式',
      outboundMethod: '出库方式',
      directStorage: '直接入库',
      purchaseStorage: '采购入库',
      emergencyPurchase: '紧急采购',
      directOutbound: '直接出库',
      auditOutbound: '审核出库',
      description: '说明：',
      referencePurchaseTotalPrice: '参考采购总价：',
      actualPurchaseTotalPrice: '实际采购总价：',
      applyMaterials: '申请物资',
      itemType: '物品类型',
      itemName: '物品名称',
      warehouse: '所属仓库',
      itemSpec: '物品规格',
      supplier: '供应商',
      itemCode: '物品编码',
      fixedItem: '固定物品',
      referencePrice: '参考单价',
      originalStock: '原有库存',
      currentStock: '现有库存',
      applyQuantity: '申请数量',
      applyRemark: '申请备注',
      purchasePrice: '采购单价',
      purchaseQuantity: '采购数量',
      receiveQuantity: '领用数量',
      purchaseRemark: '采购备注',
      receiveRemark: '领用备注',
      workOrderFlow: '工单流转',
      serialNumber: '序号',
      handler: '处理人',
      status: '状态',
      handleTime: '处理时间',
      timeConsuming: '耗时',
      opinion: '意见',
      cancel: '取消',
      time: '时间',
      manufacturerSignature: '厂家签字',
      purchaserSignature: '采购人员签字',
      remark: '备注',
      reviewerSignature: '审核人签字',
      applicantSignature: '申请人签字'
    },
    auditDiv: {
      workOrderProcessing: '工单办理',
      action: '动作',
      pleaseSelect: '请选择',
      agree: '同意',
      return: '退回',
      returnToSubmitter: '退回至提交者',
      transfer: '转单',
      workOrderDescription: '工单说明',
      requiredDescription: '必填，请填写工单说明',
      nextHandler: '下一处理人',
      requiredNextHandler: '必填，请选择下一处理人',
      select: '选择',
      pleaseSelectStatus: '请选择状态',
      pleaseFillDescription: '请填写说明',
      pleaseSelectNextHandler: '请选择下一节点处理人',
      submitSuccess: '提交成功',
      submitFailed: '提交失败'
    },
  }
}